import { createVanIconComponent } from "./van"

const WapNav = createVanIconComponent("wap-nav")
export default WapNav
